import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { HardHat, Receipt, ShieldAlert } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import CantieriPage from './CantieriPage';
import ContabilitaPage from './ContabilitaPage';

const canView = (user, section) => {
  if (!user) return false;
  if (user.is_super_admin) return true;
  const perms = user.permissions || {};
  if (!perms[section]) return true;
  return !!perms[section]?.view;
};

// Sezione unificata: Contabilità cantieri (invariata) + Gestione cantieri.
export default function CantieriContabilitaPage() {
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const canGestione = canView(user, 'cantieri');
  const canContabilita = canView(user, 'contabilita');
  const defaultTab = canContabilita ? 'contabilita' : 'gestione';
  const tab = searchParams.get('tab') || defaultTab;

  if (!canGestione && !canContabilita) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6" data-testid="perm-denied">
        <ShieldAlert className="h-16 w-16 text-red-400 mb-4" />
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Accesso negato</h1>
        <p className="text-sm text-slate-600 max-w-md">Non hai il permesso di visualizzare questa sezione.</p>
      </div>
    );
  }

  const setTab = (t) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', t);
    if (t === 'gestione') next.delete('cantiere');
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="space-y-4" data-testid="cantieri-unified-page">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-slate-100">
          {canContabilita && (
            <TabsTrigger value="contabilita" data-testid="tab-contabilita">
              <Receipt className="h-4 w-4 mr-1.5" />Contabilità
            </TabsTrigger>
          )}
          {canGestione && (
            <TabsTrigger value="gestione" data-testid="tab-gestione-cantieri">
              <HardHat className="h-4 w-4 mr-1.5" />Gestione Cantieri
            </TabsTrigger>
          )}
        </TabsList>
        {canContabilita && <TabsContent value="contabilita" className="mt-4"><ContabilitaPage /></TabsContent>}
        {canGestione && <TabsContent value="gestione" className="mt-4"><CantieriPage /></TabsContent>}
      </Tabs>
    </div>
  );
}
